<template>
  <div class="air-app popup">
    <div class="popup-mask">{{ cancelPopupState }}</div>
    <div class="popup-content">
      <div class="popup-close close-btn" @click="cancelPopupState = true"></div>
      <div class="loading" v-show="!btnState">
        <svg
          width="30px"
          height="30px"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#999"
            fill-rule="evenodd"
            d="M11,16 C12.1045695,16 13,16.8954305 13,18 C13,19.1045695 12.1045695,20 11,20 C9.8954305,20 9,19.1045695 9,18 C9,16.8954305 9.8954305,16 11,16 Z M4.74123945,13 C6.12195133,13 7.24123945,14.1192881 7.24123945,15.5 C7.24123945,16.8807119 6.12195133,18 4.74123945,18 C3.36052758,18 2.24123945,16.8807119 2.24123945,15.5 C2.24123945,14.1192881 3.36052758,13 4.74123945,13 Z M16.3193286,13.5 C17.4238981,13.5 18.3193286,14.3954305 18.3193286,15.5 C18.3193286,16.6045695 17.4238981,17.5 16.3193286,17.5 C15.2147591,17.5 14.3193286,16.6045695 14.3193286,15.5 C14.3193286,14.3954305 15.2147591,13.5 16.3193286,13.5 Z M18.5,9.31854099 C19.3284271,9.31854099 20,9.99011387 20,10.818541 C20,11.6469681 19.3284271,12.318541 18.5,12.318541 C17.6715729,12.318541 17,11.6469681 17,10.818541 C17,9.99011387 17.6715729,9.31854099 18.5,9.31854099 Z M2.5,6 C3.88071187,6 5,7.11928813 5,8.5 C5,9.88071187 3.88071187,11 2.5,11 C1.11928813,11 0,9.88071187 0,8.5 C0,7.11928813 1.11928813,6 2.5,6 Z M17.7857894,5.20724734 C18.3380741,5.20724734 18.7857894,5.65496259 18.7857894,6.20724734 C18.7857894,6.75953209 18.3380741,7.20724734 17.7857894,7.20724734 C17.2335046,7.20724734 16.7857894,6.75953209 16.7857894,6.20724734 C16.7857894,5.65496259 17.2335046,5.20724734 17.7857894,5.20724734 Z M8,0 C9.65685425,0 11,1.34314575 11,3 C11,4.65685425 9.65685425,6 8,6 C6.34314575,6 5,4.65685425 5,3 C5,1.34314575 6.34314575,0 8,0 Z M15.5,3 C15.7761424,3 16,3.22385763 16,3.5 C16,3.77614237 15.7761424,4 15.5,4 C15.2238576,4 15,3.77614237 15,3.5 C15,3.22385763 15.2238576,3 15.5,3 Z"
          />
        </svg>
      </div>

      <div class="btn-container" id="airwalletbtn" v-show="btnState">
        <!-- STEP #3a: Add an empty container for the applepay element to be injected into -->
        <div id="airEallexPay"></div>
        <!-- STEP #3b: Add a submit button to trigger the payment request -->
        <!-- <button id="submit" disabled="true" v-show="btnState">Submit</button> -->
      </div>
    </div>
    <transition name="fade">
      <div class="popup cancel-popup" v-show="cancelPopupState">
        <div class="popup-mask" @click="cancelPopupState = false"></div>
        <div class="popup-main">
          <div
            class="popup-close j-popup-close"
            @click="cancelPopupState = false"
          ></div>
          <div class="title-text">{{ letter.leaveCreditPageTips }}</div>
          <div class="btn-wrap">
            <div class="btn-item continue" @click="cancelPopupState = false">
              {{ letter.continueToPay }}
            </div>
            <div class="btn-item leave" @click="canclePay">
              {{ letter.sureToLeave }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { injectScript } from '../../utiles';
import { mapState } from 'vuex';

const AIRWALLEX_JSSDK_URL =
  'https://checkout.airwallex.com/assets/elements.bundle.min.js';

let airWallexPay = null;

export default {
  name: 'airWallexBtn',
  props: ['airWallexInfo', 'failTips'],
  data() {
    return { btnState: false, cancelPopupState: false };
  },
  computed: {
    ...mapState({
      letter: state => state.letter || state?.cash?.letter || {}
    })
  },
  created() {
    injectScript(AIRWALLEX_JSSDK_URL, () => {
      this.sendDataLayer('airwallex_payment_init');
      try {
        // STEP #2: Initialize the Airwallex global context for event communication
        Airwallex.init({
          env: this.airWallexInfo.env, // Setup which Airwallex env('staging' | 'demo' | 'prod') to integrate with
          origin: window.location.origin, // Setup your event target to receive the browser events message
          fonts: [
            // Customizes the font for the payment elements
            {
              src: 'https://checkout.airwallex.com/fonts/CircularXXWeb/CircularXXWeb-Regular.woff2',
              family: 'AxLLCircular',
              weight: 400
            }
          ]
        });

        let curElement = '';
        let info = {
          mode: 'payment',
          intent_id: this.airWallexInfo.intent_id,
          origin: window.location.origin,
          client_secret: this.airWallexInfo.client_secret,
          countryCode: this.airWallexInfo.location,
          buttonType: 'buy',
          amount: {
            value: +this.airWallexInfo.trans_amount,
            currency: this.airWallexInfo.currency
          }
          // 暂时注释：后面改按钮大小用的
          // appearance: {
          //   rules: {
          //     '.GooglePayButton': {
          //       width: '600px',
          //       height: '160px',
          //       borderRadius: '28px'
          //     },
          //     '.ApplePayButton': {
          //       width: '600px',
          //       height: '160px',
          //       borderRadius: '28px'
          //     }
          //   }
          // }
        };
        if (this.airWallexInfo.pay_type == 'applepay') {
          curElement = 'applePayButton';
          Object.assign(info, {
            requiredBillingContactFields: [
              'postalAddress',
              'name',
              'email',
              'phone'
            ]
          });
        }
        if (this.airWallexInfo.pay_type == 'googlepay') {
          curElement = 'googlePayButton';
          Object.assign(info, {
            emailRequired: true,
            billingAddressParameters: {
              format: 'FULL',
              phoneNumberRequired: true
            },
            billingAddressRequired: true
          });
        }
        airWallexPay = Airwallex.createElement(curElement, info);

        // STEP #5: Mount applepay element
        const domElement = airWallexPay.mount('airEallexPay');

        // STEP #6: Add an event listener to ensure the element is mounted
        domElement.addEventListener('onReady', event => {
          this.sendDataLayer('airwallex_payment_ready');
          this.btnState = true;
        });

        // STEP #7: Add an event listener to handle errors
        domElement.addEventListener('onError', event => {
          const { error } = event.detail;
          this.sendDataLayer('airwallex_payment_failed_onError', {
            error: error?.message || 'unknown error'
          });
          console.error('error', error);
          let dataTxt = '';
          try {
            dataTxt = encodeURIComponent(JSON.stringify(error));
          } catch (error) {}
          let url = new URL(
            this.airWallexInfo.fail_url || this.airWallexInfo.successUrl
          );
          url.searchParams.set('msg', encodeURIComponent(this.failTips));
          url.searchParams.set('data', dataTxt);
          window.location.href = url.href;
        });

        // STEP #8: Add an event listener to handle errors
        domElement.addEventListener('onSuccess', event => {
          this.sendDataLayer('airwallex_payment_success');
          // handle your success event
          window.location.href =
            this.airWallexInfo.success_url || this.airWallexInfo.successUrl;
        });
      } catch (error) {
        this.sendDataLayer('airwallex_payment_failed_catch', {
          error: error?.message || 'unknown error'
        });
        console.error('There was an loading error', error);
      }
    });
  },
  beforeDestroy() {
    this.deleteAirWallexPay();
  },
  emit: ['closePopup'],
  methods: {
    canclePay() {
      this.deleteAirWallexPay();
      this.$emit('closePopup');
    },
    deleteAirWallexPay() {
      if (airWallexPay) {
        try {
          airWallexPay.destroy();
        } catch (error) {}
      }
    },
    sendDataLayer(eventName, eventValue = {}) {
      if (window.isOfficialTopupNew) {
        window.webstorev35DataLayer.push({
          eventName,
          eventValue
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 100;

  &-mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  &-content {
    background-color: #f3f3f3;
    height: 20vh;
    width: 100%;
    padding: 30px 30px 50px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  &-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 24px;
    height: 24px;
    background: no-repeat center url(../../assets/image/icons/closeBtn.png);
  }
}

.btn-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: scale(1.5);
  iframe {
    max-height: 48px;
  }
}

.loading {
  animation: loaddingRotate 3s infinite;
}
@keyframes loaddingRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

$img: '~@assets/image/cash/';
.cancel-popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  .popup-mask {
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
  .popup-main {
    width: 420px;
    max-height: 80%;
    max-width: 95%;
    height: 250px;
    border-radius: 12px;
    box-sizing: border-box;
    padding: 30px 60px;
    background: #fff;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: auto;
    .popup-close {
      position: absolute;
      right: 5px;
      top: 5px;
      font-size: 16px;
      padding: 10px;
      cursor: pointer;
    }
    .title-text {
      font-size: 18px;
      line-height: 1.3;
      font-weight: 600;
      color: #00112c;
      text-align: center;
    }
    .btn-wrap {
      display: flex;
      justify-content: space-evenly;
      margin-top: 60px;
      .btn-item {
        font-size: 16px;
        padding: 12px;
        cursor: pointer;
        border-radius: 6px;
        transition: all 0.3s;
        &.continue {
          color: #000;
          background: #fff;
          margin-right: 20px;
          border: 1px solid #e6e9eb;
          &:hover {
            background: #f7f8f9;
          }
        }
        &.leave {
          background: #ac2020;
          color: #fff;
          border: 1px solid #ac2020;
          &:hover {
            background: #c91515;
          }
        }
      }
    }
  }
}
</style>
